import axios from "../../axios/axios";

import * as apis from "../../apis";
import * as errors from "../../errors"
import * as successes from "../../successes"

import { getAxiosTokenConfig } from "../../helpers";

import { notifyError, notifySuccess } from "../../toast-notifications";
import { CLOSE_CUSTOM_EVENT_MODAL } from "./ui";
import { getReservations } from "./reservations";
import { LEGACY_EXPAND_ALL_COMMENTS_SETTING, SHOW_RESERVATION_DETAILS_BY_VIEW_SETTING } from "@/constants/settings";
import { USE_NEW_BOOKER_UI } from "@/constants/featureFlags";
import { WORKSPACE_VIEWS } from "@/constants/booker";


// GET RESTAURANT SETTINGS
export const GET_RESTAURANT_SETTINGS_REQUEST = "GET_RESTAURANT_SETTINGS_REQUEST";
export const GET_RESTAURANT_SETTINGS_SUCCESS = "GET_RESTAURANT_SETTINGS_SUCCESS";
export const GET_RESTAURANT_SETTINGS_ERROR = "GET_RESTAURANT_SETTINGS_ERROR";

export const getRestaurantSettingsRequest = () => {
    return {
        type: GET_RESTAURANT_SETTINGS_REQUEST,
        loading: true
    };
};
export const getRestaurantSettingsSuccess = (restaurantSettings) => {
    return {
        type: GET_RESTAURANT_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        restaurantSettings
    };
};
export const getRestaurantSettingsError = (error) => {
    return {
        type: GET_RESTAURANT_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const getRestaurantSettings = () => {
    return dispatch => {
        dispatch(getRestaurantSettingsRequest());
        axios.get(apis.GET_RESTAURANT_SETTINGS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getRestaurantSettingsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getRestaurantSettingsError(errors.GET_RESTAURANT_SETTINGS_ERROR));
                notifyError(errors.GET_RESTAURANT_SETTINGS_ERROR);
            });
    };
};

// UPDATE RESTAURANT SETTINGS
export const UPDATE_RESTAURANT_SETTINGS_REQUEST = "UPDATE_RESTAURANT_SETTINGS_REQUEST";
export const UPDATE_RESTAURANT_SETTINGS_SUCCESS = "UPDATE_RESTAURANT_SETTINGS_SUCCESS";
export const UPDATE_RESTAURANT_SETTINGS_ERROR = "UPDATE_RESTAURANT_SETTINGS_ERROR";

export const updateRestaurantSettingsRequest = () => {
    return {
        type: UPDATE_RESTAURANT_SETTINGS_REQUEST,
        loading: true
    };
};
export const updateRestaurantSettingsSuccess = (restaurantSettings) => {
    return {
        type: UPDATE_RESTAURANT_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        restaurantSettings
    };
};
export const updateRestaurantSettingsError = (error) => {
    return {
        type: UPDATE_RESTAURANT_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const updateRestaurantSettings = (restaurantSettings) => {
    return dispatch => {
        dispatch(updateRestaurantSettingsRequest());

        const config = getAxiosTokenConfig();
        config.headers['content-type'] = 'multipart/form-data';

        const settings = {};
        const formDataSettings = new FormData();
        let formDataExists = false;
        Object.keys(restaurantSettings).map(key => {
            const value = restaurantSettings[key];
            if (["logo", "banner"].includes(key)) {
                if (typeof value !== "string") {
                    if (value === null) {
                        settings[key] = value;
                    }
                    else {
                        formDataSettings.append(key, value);
                        formDataExists = true;
                    }
                }
            }
            else {
                settings[key] = value;
            }
        });

        axios.patch(apis.UPDATE_RESTAURANT_SETTINGS_API, settings, getAxiosTokenConfig())
            .then(response => {
                if (formDataExists) {
                    axios.patch(apis.UPDATE_RESTAURANT_SETTINGS_API, formDataSettings, config)
                        .then(response => {
                            dispatch(updateRestaurantSettingsSuccess(response.data));
                            notifySuccess(successes.UPDATE_RESTAURANT_SETTINGS_SUCCESS);
                        })
                        .catch(error => {
                            dispatch(updateRestaurantSettingsError(error));
                            notifyError(errors.UPDATE_RESTAURANT_SETTINGS_ERROR);
                        });
                }
                else {
                    dispatch(updateRestaurantSettingsSuccess(response.data));
                    notifySuccess(successes.UPDATE_RESTAURANT_SETTINGS_SUCCESS);
                }
            })
            .catch(error => {
                dispatch(updateRestaurantSettingsError(error));
                notifyError(errors.UPDATE_RESTAURANT_SETTINGS_ERROR);
            });
    };
};

// GET EMAIL SETTINGS
export const GET_EMAIL_SETTINGS_REQUEST = "GET_EMAIL_SETTINGS_REQUEST";
export const GET_EMAIL_SETTINGS_SUCCESS = "GET_EMAIL_SETTINGS_SUCCESS";
export const GET_EMAIL_SETTINGS_ERROR = "GET_EMAIL_SETTINGS_ERROR";

export const getEmailSettingsRequest = () => {
    return {
        type: GET_EMAIL_SETTINGS_REQUEST,
        loading: true
    };
};
export const getEmailSettingsSuccess = (emailSettings) => {
    return {
        type: GET_EMAIL_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        emailSettings
    };
};
export const getEmailSettingsError = (error) => {
    return {
        type: GET_EMAIL_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const getEmailSettings = () => {
    return dispatch => {
        dispatch(getEmailSettingsRequest());
        axios.get(apis.GET_EMAIL_SETTINGS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getEmailSettingsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getEmailSettingsError(errors.GET_EMAIL_SETTINGS_ERROR));
                notifyError(errors.GET_EMAIL_SETTINGS_ERROR);
            });
    };
};

// UPDATE EMAIL SETTINGS
export const UPDATE_EMAIL_SETTINGS_REQUEST = "UPDATE_EMAIL_SETTINGS_REQUEST";
export const UPDATE_EMAIL_SETTINGS_SUCCESS = "UPDATE_EMAIL_SETTINGS_SUCCESS";
export const UPDATE_EMAIL_SETTINGS_ERROR = "UPDATE_EMAIL_SETTINGS_ERROR";

export const updateEmailSettingsRequest = () => {
    return {
        type: UPDATE_EMAIL_SETTINGS_REQUEST,
        loading: true
    };
};
export const updateEmailSettingsSuccess = (emailSettings) => {
    return {
        type: UPDATE_EMAIL_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        emailSettings
    };
};
export const updateEmailSettingsError = (error) => {
    return {
        type: UPDATE_EMAIL_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const updateEmailSettings = (table) => {
    return dispatch => {
        dispatch(updateEmailSettingsRequest());
        axios.patch(apis.UPDATE_EMAIL_SETTINGS_API, table, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateEmailSettingsSuccess(response.data));
                notifySuccess(successes.UPDATE_EMAIL_SETTINGS_SUCCESS);
            })
            .catch(error => {
                dispatch(updateEmailSettingsError(error));
                notifyError(errors.UPDATE_EMAIL_SETTINGS_ERROR);
            });
    };
};

// GET APP SETTINGS
export const GET_APP_SETTINGS = "GET_APP_SETTINGS";

export const getAppSettings = () => {
    return dispatch => {
        const appSettings = JSON.parse(localStorage.getItem("appSettings")) ?? {};
        if (
            appSettings[SHOW_RESERVATION_DETAILS_BY_VIEW_SETTING] === undefined &&
            typeof appSettings[LEGACY_EXPAND_ALL_COMMENTS_SETTING] === "boolean" &&
            USE_NEW_BOOKER_UI
        ) {
            appSettings[SHOW_RESERVATION_DETAILS_BY_VIEW_SETTING] = {
                [WORKSPACE_VIEWS.LIST]: appSettings[LEGACY_EXPAND_ALL_COMMENTS_SETTING],
                [WORKSPACE_VIEWS.TIMELINE]: appSettings[LEGACY_EXPAND_ALL_COMMENTS_SETTING],
                [WORKSPACE_VIEWS.FLOORPLAN]: appSettings[LEGACY_EXPAND_ALL_COMMENTS_SETTING],
            };
            localStorage.setItem("appSettings", JSON.stringify(appSettings));
        }
        dispatch({
            type: GET_APP_SETTINGS,
            appSettings,
        });
    };
};

// UPDATE APP SETTINGS
export const UPDATE_APP_SETTINGS = "UPDATE_APP_SETTINGS";

export const updateAppSettings = (appSettings = {}) => {
    return dispatch => {
        const currentAppSettings = JSON.parse(localStorage.getItem("appSettings"));
        const isGetter = typeof appSettings === "function";
        const appendedAppSettings = isGetter ? appSettings(currentAppSettings) : appSettings;
        const newAppSettings = { ...currentAppSettings, ...appendedAppSettings, };
        localStorage.setItem("appSettings", JSON.stringify(newAppSettings));
        dispatch({
            type: UPDATE_APP_SETTINGS,
            appSettings: newAppSettings,
        });
    };
};

// TOGGLE OPENING HOUR MODAL
export const TOGGLE_OPENING_HOUR_MODAL = "TOGGLE_OPENING_HOUR_MODAL";

export const toggleOpeningHourModal = () => {
    return dispatch => {
        dispatch({ type: TOGGLE_OPENING_HOUR_MODAL })
    }
}

// GET OPENING HOURS
export const GET_OPENING_HOURS_REQUEST = "GET_OPENING_HOURS_REQUEST";
export const GET_OPENING_HOURS_SUCCESS = "GET_OPENING_HOURS_SUCCESS";
export const GET_OPENING_HOURS_ERROR = "GET_OPENING_HOURS_ERROR";

export const getOpeningHoursRequest = () => {
    return {
        type: GET_OPENING_HOURS_REQUEST,
        loading: true
    };
};
export const getOpeningHoursSuccess = (openingHours) => {
    return {
        type: GET_OPENING_HOURS_SUCCESS,
        loading: false,
        error: null,
        openingHours
    };
};
export const getOpeningHoursError = (error) => {
    return {
        type: GET_OPENING_HOURS_ERROR,
        loading: false,
        error
    };
};
export const getOpeningHours = () => {
    return dispatch => {
        dispatch(getOpeningHoursRequest());
        axios.get(apis.GET_OPENING_HOURS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getOpeningHoursSuccess(response.data));
            })
            .catch(error => {
                dispatch(getOpeningHoursError(errors.GET_OPENING_HOURS_ERROR));
                notifyError(errors.GET_OPENING_HOURS_ERROR);
            });
    }
};

// ADD OPENING_HOUR
export const ADD_OPENING_HOUR_REQUEST = "ADD_OPENING_HOUR_REQUEST";
export const ADD_OPENING_HOUR_SUCCESS = "ADD_OPENING_HOUR_SUCCESS";
export const ADD_OPENING_HOUR_ERROR = "ADD_OPENING_HOUR_ERROR";

export const addOpeningHourRequest = () => {
    return {
        type: ADD_OPENING_HOUR_REQUEST,
        loading: true
    };
};
export const addOpeningHourSuccess = (openingHour) => {
    return {
        type: ADD_OPENING_HOUR_SUCCESS,
        loading: false,
        error: null,
        openingHour
    };
};
export const addOpeningHourError = (error) => {
    return {
        type: ADD_OPENING_HOUR_ERROR,
        loading: false,
        error
    };
};
export const addOpeningHour = (openingHour) => {
    return dispatch => {
        dispatch(addOpeningHourRequest());
        axios.post(apis.ADD_OPENING_HOUR_API, openingHour, getAxiosTokenConfig())
            .then(response => {
                dispatch(addOpeningHourSuccess(response.data));
                notifySuccess(successes.ADD_OPENING_HOUR_SUCCESS)
            })
            .catch(error => {
                dispatch(addOpeningHourError(errors.ADD_OPENING_HOUR_ERROR));
                notifyError(errors.ADD_OPENING_HOUR_ERROR);
            })
            .finally(() => {
                dispatch(toggleOpeningHourModal())
            });
    }
};

// UPDATE OPENING_HOUR
export const UPDATE_OPENING_HOUR_REQUEST = "UPDATE_OPENING_HOUR_REQUEST";
export const UPDATE_OPENING_HOUR_SUCCESS = "UPDATE_OPENING_HOUR_SUCCESS";
export const UPDATE_OPENING_HOUR_ERROR = "UPDATE_OPENING_HOUR_ERROR";

export const updateOpeningHourRequest = () => {
    return {
        type: UPDATE_OPENING_HOUR_REQUEST,
        loading: true
    };
};
export const updateOpeningHourSuccess = (openingHour) => {
    return {
        type: UPDATE_OPENING_HOUR_SUCCESS,
        loading: false,
        error: null,
        openingHour
    };
};
export const updateOpeningHourError = (error) => {
    return {
        type: UPDATE_OPENING_HOUR_ERROR,
        loading: false,
        error
    };
};
export const updateOpeningHour = (openingHour) => {
    return dispatch => {
        dispatch(updateOpeningHourRequest());

        axios.patch(apis.UPDATE_OPENING_HOUR_API + openingHour.id + "/", openingHour, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateOpeningHourSuccess(response.data));
                notifySuccess(successes.UPDATE_OPENING_HOUR_SUCCESS)
            })
            .catch(error => {
                dispatch(updateOpeningHourError(errors.UPDATE_OPENING_HOUR_ERROR));
                notifyError(errors.UPDATE_OPENING_HOUR_ERROR);
            })
            .finally(() => {
                dispatch(toggleOpeningHourModal());
            });
    }
};

// DELETE OPENING_HOUR
export const DELETE_OPENING_HOUR_REQUEST = "DELETE_OPENING_HOUR_REQUEST";
export const DELETE_OPENING_HOUR_SUCCESS = "DELETE_OPENING_HOUR_SUCCESS";
export const DELETE_OPENING_HOUR_ERROR = "DELETE_OPENING_HOUR_ERROR";

export const deleteOpeningHourRequest = () => {
    return {
        type: DELETE_OPENING_HOUR_REQUEST,
        loading: true
    };
};
export const deleteOpeningHourSuccess = (openingHourId) => {
    return {
        type: DELETE_OPENING_HOUR_SUCCESS,
        loading: false,
        error: null,
        openingHourId
    };
};
export const deleteOpeningHourError = (error) => {
    return {
        type: DELETE_OPENING_HOUR_ERROR,
        loading: false,
        error
    };
};
export const deleteOpeningHour = (openingHour) => {
    return dispatch => {
        dispatch(deleteOpeningHourRequest());
        axios.delete(apis.DELETE_OPENING_HOUR_API + openingHour.id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteOpeningHourSuccess(openingHour.id));
                notifySuccess(successes.DELETE_OPENING_HOUR_SUCCESS)
            })
            .catch(error => {
                dispatch(deleteOpeningHourError(errors.DELETE_OPENING_HOUR_ERROR));
                notifyError(errors.DELETE_OPENING_HOUR_ERROR);
            })
            .finally(() => {
                dispatch(toggleOpeningHourModal());
            });
    }
};

// GET CUSTOM_EVENTS
export const GET_CUSTOM_EVENTS_REQUEST = "GET_CUSTOM_EVENTS_REQUEST";
export const GET_CUSTOM_EVENTS_SUCCESS = "GET_CUSTOM_EVENTS_SUCCESS";
export const GET_CUSTOM_EVENTS_ERROR = "GET_CUSTOM_EVENTS_ERROR";

export const getCustomEventsRequest = () => {
    return {
        type: GET_CUSTOM_EVENTS_REQUEST,
        loading: true
    };
};
export const getCustomEventsSuccess = (customEvents) => {
    return {
        type: GET_CUSTOM_EVENTS_SUCCESS,
        loading: false,
        error: null,
        customEvents
    };
};
export const getCustomEventsError = (error) => {
    return {
        type: GET_CUSTOM_EVENTS_ERROR,
        loading: false,
        error
    };
};
export const getCustomEvents = () => {
    return dispatch => {
        dispatch(getCustomEventsRequest());
        axios.get(apis.GET_CUSTOM_EVENTS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(getCustomEventsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getCustomEventsError(errors.GET_CUSTOM_EVENTS_ERROR));
                notifyError(errors.GET_CUSTOM_EVENTS_ERROR);
            });
    };
};

// ADD CUSTOM_EVENT
export const ADD_CUSTOM_EVENT_REQUEST = "ADD_CUSTOM_EVENT_REQUEST";
export const ADD_CUSTOM_EVENT_SUCCESS = "ADD_CUSTOM_EVENT_SUCCESS";
export const ADD_CUSTOM_EVENT_ERROR = "ADD_CUSTOM_EVENT_ERROR";

export const addCustomEventRequest = () => {
    return {
        type: ADD_CUSTOM_EVENT_REQUEST,
        loading: true
    };
};
export const addCustomEventSuccess = (customEvent) => {
    return {
        type: ADD_CUSTOM_EVENT_SUCCESS,
        loading: false,
        error: null,
        customEvent
    };
};
export const addCustomEventError = (error) => {
    return {
        type: ADD_CUSTOM_EVENT_ERROR,
        loading: false,
        error
    };
};
export const addCustomEvent = (customEvent) => {
    return dispatch => {
        dispatch(addCustomEventRequest());
        axios.post(apis.ADD_CUSTOM_EVENT_API, customEvent, getAxiosTokenConfig())
            .then(response => {
                dispatch(addCustomEventSuccess(response.data));
                notifySuccess(successes.ADD_CUSTOM_EVENT_SUCCESS);
            })
            .catch(error => {
                dispatch(addCustomEventError(errors.ADD_CUSTOM_EVENT_ERROR));
                notifyError(errors.ADD_CUSTOM_EVENT_ERROR);
            });
    };
};

// DELETE CUSTOM_EVENT
export const DELETE_CUSTOM_EVENT_REQUEST = "DELETE_CUSTOM_EVENT_REQUEST";
export const DELETE_CUSTOM_EVENT_SUCCESS = "DELETE_CUSTOM_EVENT_SUCCESS";
export const DELETE_CUSTOM_EVENT_ERROR = "DELETE_CUSTOM_EVENT_ERROR";

export const deleteCustomEventRequest = () => {
    return {
        type: DELETE_CUSTOM_EVENT_REQUEST,
        loading: true
    };
};
export const deleteCustomEventSuccess = (customEventId) => {
    return {
        type: DELETE_CUSTOM_EVENT_SUCCESS,
        loading: false,
        error: null,
        customEventId
    };
};
export const deleteCustomEventError = (error) => {
    return {
        type: DELETE_CUSTOM_EVENT_ERROR,
        loading: false,
        error
    };
};
export const deleteCustomEvent = (id) => {
    return dispatch => {
        dispatch(deleteCustomEventRequest());
        axios.delete(apis.DELETE_CUSTOM_EVENT_API + id + "/", getAxiosTokenConfig())
            .then(response => {
                dispatch(deleteCustomEventSuccess(id));
                dispatch(getReservations());
                notifySuccess(successes.DELETE_CUSTOM_EVENT_SUCCESS);
            })
            .catch(error => {
                dispatch(deleteCustomEventError(error));
                notifyError(errors.DELETE_CUSTOM_EVENT_ERROR);
            });
    };
};

// UPDATE CUSTOM_EVENT
export const UPDATE_CUSTOM_EVENT_REQUEST = "UPDATE_CUSTOM_EVENT_REQUEST";
export const UPDATE_CUSTOM_EVENT_SUCCESS = "UPDATE_CUSTOM_EVENT_SUCCESS";
export const UPDATE_CUSTOM_EVENT_ERROR = "UPDATE_CUSTOM_EVENT_ERROR";

export const updateCustomEventRequest = () => {
    return {
        type: UPDATE_CUSTOM_EVENT_REQUEST,
        loading: true
    };
};
export const updateCustomEventSuccess = (customEvent) => {
    return {
        type: UPDATE_CUSTOM_EVENT_SUCCESS,
        loading: false,
        error: null,
        customEvent
    };
};
export const updateCustomEventError = (error) => {
    return {
        type: UPDATE_CUSTOM_EVENT_ERROR,
        loading: false,
        error
    };
};
export const updateCustomEvent = (customEvent) => {
    return dispatch => {
        dispatch(updateCustomEventRequest());
        axios.patch(apis.UPDATE_CUSTOM_EVENT_API + customEvent.id + "/", customEvent, getAxiosTokenConfig())
            .then(response => {
                dispatch(updateCustomEventSuccess(response.data));
                notifySuccess(successes.UPDATE_CUSTOM_EVENT_SUCCESS);
            })
            .catch(error => {
                dispatch(updateCustomEventError(error));
                notifyError(errors.UPDATE_CUSTOM_EVENT_ERROR);
            });
    };
};

const sendAction = (type, meta = null) => (meta ? { type, ...meta } : { type });

// GET MESSAGE SAMPLES
export const GET_MESSAGE_SAMPLES_REQUEST = "GET_MESSAGE_SAMPLES_REQUEST";
export const GET_MESSAGE_SAMPLES_SUCCESS = "GET_MESSAGE_SAMPLES_SUCCESS";
export const GET_MESSAGE_SAMPLES_ERROR = "GET_MESSAGE_SAMPLES_ERROR";


export const getMessageSamples = () => {
    return dispatch => {
        dispatch(sendAction(GET_MESSAGE_SAMPLES_REQUEST));
        axios.get(apis.MESSAGE_SAMPLES_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(GET_MESSAGE_SAMPLES_SUCCESS, { data: response.data }));
            })
            .catch(error => {
                dispatch(sendAction(GET_MESSAGE_SAMPLES_ERROR, { error }));
                notifyError(errors.GET_MESSAGE_SAMPLES_ERROR);
            });
    };
}

// ADD MESSAGE SAMPLE
export const ADD_MESSAGE_SAMPLE_REQUEST = "ADD_MESSAGE_SAMPLE_REQUEST";
export const ADD_MESSAGE_SAMPLE_SUCCESS = "ADD_MESSAGE_SAMPLE_SUCCESS";
export const ADD_MESSAGE_SAMPLE_ERROR = "ADD_MESSAGE_SAMPLE_ERROR";


export const addMessageSample = sample => {
    return dispatch => {
        dispatch(sendAction(ADD_MESSAGE_SAMPLE_REQUEST));
        axios.post(apis.MESSAGE_SAMPLES_API, sample, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(ADD_MESSAGE_SAMPLE_SUCCESS, { data: response.data }));
                notifySuccess(successes.ADD_MESSAGE_SAMPLE_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(ADD_MESSAGE_SAMPLE_ERROR, { error }));
                notifyError(errors.ADD_MESSAGE_SAMPLE_ERROR);
            });
    };
}

// UPDATE MESSAGE SAMPLE
export const UPDATE_MESSAGE_SAMPLE_REQUEST = "UPDATE_MESSAGE_SAMPLE_REQUEST";
export const UPDATE_MESSAGE_SAMPLE_SUCCESS = "UPDATE_MESSAGE_SAMPLE_SUCCESS";
export const UPDATE_MESSAGE_SAMPLE_ERROR = "UPDATE_MESSAGE_SAMPLE_ERROR";


export const updateMessageSample = sample => {
    return dispatch => {
        dispatch(sendAction(UPDATE_MESSAGE_SAMPLE_REQUEST));
        axios.patch(`${apis.MESSAGE_SAMPLES_API}${sample.id}/`, sample, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(UPDATE_MESSAGE_SAMPLE_SUCCESS, { data: response.data }));
                notifySuccess(successes.UPDATE_MESSAGE_SAMPLE_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(UPDATE_MESSAGE_SAMPLE_ERROR, { error }));
                notifyError(errors.UPDATE_MESSAGE_SAMPLE_ERROR);
            });
    };
}

// DELETE MESSAGE SAMPLE
export const DELETE_MESSAGE_SAMPLE_REQUEST = "DELETE_MESSAGE_SAMPLE_REQUEST";
export const DELETE_MESSAGE_SAMPLE_SUCCESS = "DELETE_MESSAGE_SAMPLE_SUCCESS";
export const DELETE_MESSAGE_SAMPLE_ERROR = "DELETE_MESSAGE_SAMPLE_ERROR";


export const deleteMessageSample = id => {
    return dispatch => {
        dispatch(sendAction(DELETE_MESSAGE_SAMPLE_REQUEST));
        axios.delete(`${apis.MESSAGE_SAMPLES_API}${id}/`, getAxiosTokenConfig())
            .then(() => {
                dispatch(sendAction(DELETE_MESSAGE_SAMPLE_SUCCESS, { id }));
                notifySuccess(successes.DELETE_MESSAGE_SAMPLE_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(DELETE_MESSAGE_SAMPLE_ERROR, { error }));
                notifyError(errors.DELETE_MESSAGE_SAMPLE_ERROR);
            });
    };
}


// GET CONDITIONS
export const GET_RESERVATION_CONDITIONS_REQUEST = "GET_RESERVATION_CONDITIONS_REQUEST";
export const GET_RESERVATION_CONDITIONS_SUCCESS = "GET_RESERVATION_CONDITIONS_SUCCESS";
export const GET_RESERVATION_CONDITIONS_ERROR = "GET_RESERVATION_CONDITIONS_ERROR";


export const getReservationConditions = () => {
    return dispatch => {
        dispatch(sendAction(GET_RESERVATION_CONDITIONS_REQUEST));
        axios.get(apis.RESERVATION_CONDITIONS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(GET_RESERVATION_CONDITIONS_SUCCESS, { data: response.data }));
            })
            .catch(error => {
                dispatch(sendAction(GET_RESERVATION_CONDITIONS_ERROR, { error }));
                notifyError(errors.GET_RESERVATION_CONDITIONS_ERROR);
            });
    };
}

// ADD CONDITION
export const ADD_RESERVATION_CONDITION_REQUEST = "ADD_RESERVATION_CONDITION_REQUEST";
export const ADD_RESERVATION_CONDITION_SUCCESS = "ADD_RESERVATION_CONDITION_SUCCESS";
export const ADD_RESERVATION_CONDITION_ERROR = "ADD_RESERVATION_CONDITION_ERROR";


export const addReservationCondition = condition => {
    return dispatch => {
        dispatch(sendAction(ADD_RESERVATION_CONDITION_REQUEST));
        axios.post(apis.RESERVATION_CONDITIONS_API, condition, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(ADD_RESERVATION_CONDITION_SUCCESS, { data: response.data }));
                notifySuccess(successes.ADD_RESERVATION_CONDITION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(ADD_RESERVATION_CONDITION_ERROR, { error }));
                notifyError(errors.ADD_RESERVATION_CONDITION_ERROR);
            });
    };
}

// UPDATE CONDITION
export const UPDATE_RESERVATION_CONDITION_REQUEST = "UPDATE_RESERVATION_CONDITION_REQUEST";
export const UPDATE_RESERVATION_CONDITION_SUCCESS = "UPDATE_RESERVATION_CONDITION_SUCCESS";
export const UPDATE_RESERVATION_CONDITION_ERROR = "UPDATE_RESERVATION_CONDITION_ERROR";


export const updateReservationCondition = condition => {
    return dispatch => {
        dispatch(sendAction(UPDATE_RESERVATION_CONDITION_REQUEST));
        axios.patch(`${apis.RESERVATION_CONDITIONS_API}${condition.id}/`, condition, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(UPDATE_RESERVATION_CONDITION_SUCCESS, { data: response.data }));
                notifySuccess(successes.UPDATE_RESERVATION_CONDITION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(UPDATE_RESERVATION_CONDITION_ERROR, { error }));
                notifyError(errors.UPDATE_RESERVATION_CONDITION_ERROR);
            });
    };
}

// DELETE CONDITION
export const DELETE_RESERVATION_CONDITION_REQUEST = "DELETE_RESERVATION_CONDITION_REQUEST";
export const DELETE_RESERVATION_CONDITION_SUCCESS = "DELETE_RESERVATION_CONDITION_SUCCESS";
export const DELETE_RESERVATION_CONDITION_ERROR = "DELETE_RESERVATION_CONDITION_ERROR";


export const deleteReservationCondition = id => {
    return dispatch => {
        dispatch(sendAction(DELETE_RESERVATION_CONDITION_REQUEST));
        axios.delete(`${apis.RESERVATION_CONDITIONS_API}${id}/`, getAxiosTokenConfig())
            .then(() => {
                dispatch(sendAction(DELETE_RESERVATION_CONDITION_SUCCESS, { id }));
                notifySuccess(successes.DELETE_RESERVATION_CONDITION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(DELETE_RESERVATION_CONDITION_ERROR, { error }));
                notifyError(errors.DELETE_RESERVATION_CONDITION_ERROR);
            });
    };
}

// GET CONDITIONS
export const GET_SPECIAL_OPTION_CATEGORIES_REQUEST = "GET_SPECIAL_OPTION_CATEGORIES_REQUEST";
export const GET_SPECIAL_OPTION_CATEGORIES_SUCCESS = "GET_SPECIAL_OPTION_CATEGORIES_SUCCESS";
export const GET_SPECIAL_OPTION_CATEGORIES_ERROR = "GET_SPECIAL_OPTION_CATEGORIES_ERROR";


export const getSpecialOptionCategories = () => {
    return dispatch => {
        dispatch(sendAction(GET_SPECIAL_OPTION_CATEGORIES_REQUEST));
        axios.get(apis.SPECIAL_OPTION_CATEGORIES_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(GET_SPECIAL_OPTION_CATEGORIES_SUCCESS, { data: response.data }));
            })
            .catch(error => {
                dispatch(sendAction(GET_SPECIAL_OPTION_CATEGORIES_ERROR, { error }));
                notifyError(errors.GET_SPECIAL_OPTION_CATEGORIES_ERROR);
            });
    };
}

// ADD CONDITION
export const ADD_SPECIAL_OPTION_CATEGORY_REQUEST = "ADD_SPECIAL_OPTION_CATEGORY_REQUEST";
export const ADD_SPECIAL_OPTION_CATEGORY_SUCCESS = "ADD_SPECIAL_OPTION_CATEGORY_SUCCESS";
export const ADD_SPECIAL_OPTION_CATEGORY_ERROR = "ADD_SPECIAL_OPTION_CATEGORY_ERROR";


export const addSpecialOptionCategory = (category, tag = null) => {
    return dispatch => {
        dispatch(sendAction(ADD_SPECIAL_OPTION_CATEGORY_REQUEST));
        axios.post(apis.SPECIAL_OPTION_CATEGORIES_API, category, getAxiosTokenConfig())
            .then(response => {
                if (tag) response.data.creation_tag = tag;
                dispatch(sendAction(ADD_SPECIAL_OPTION_CATEGORY_SUCCESS, { data: response.data }));
                notifySuccess(successes.ADD_SPECIAL_OPTION_CATEGORY_SUCCESS);
                dispatch(getSpecialOptions());
            })
            .catch(error => {
                dispatch(sendAction(ADD_SPECIAL_OPTION_CATEGORY_ERROR, { error }));
                notifyError(errors.ADD_SPECIAL_OPTION_CATEGORY_ERROR);
            });
    };
}

// UPDATE CONDITION
export const UPDATE_SPECIAL_OPTION_CATEGORY_REQUEST = "UPDATE_SPECIAL_OPTION_CATEGORY_REQUEST";
export const UPDATE_SPECIAL_OPTION_CATEGORY_SUCCESS = "UPDATE_SPECIAL_OPTION_CATEGORY_SUCCESS";
export const UPDATE_SPECIAL_OPTION_CATEGORY_ERROR = "UPDATE_SPECIAL_OPTION_CATEGORY_ERROR";


export const updateSpecialOptionCategory = category => {
    return dispatch => {
        dispatch(sendAction(UPDATE_SPECIAL_OPTION_CATEGORY_REQUEST));
        axios.patch(`${apis.SPECIAL_OPTION_CATEGORIES_API}${category.id}/`, category, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(UPDATE_SPECIAL_OPTION_CATEGORY_SUCCESS, { data: response.data }));
                notifySuccess(successes.UPDATE_SPECIAL_OPTION_CATEGORY_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(UPDATE_SPECIAL_OPTION_CATEGORY_ERROR, { error }));
                notifyError(errors.UPDATE_SPECIAL_OPTION_CATEGORY_ERROR);
            });
    };
}

// DELETE CONDITION
export const DELETE_SPECIAL_OPTION_CATEGORY_REQUEST = "DELETE_SPECIAL_OPTION_CATEGORY_REQUEST";
export const DELETE_SPECIAL_OPTION_CATEGORY_SUCCESS = "DELETE_SPECIAL_OPTION_CATEGORY_SUCCESS";
export const DELETE_SPECIAL_OPTION_CATEGORY_ERROR = "DELETE_SPECIAL_OPTION_CATEGORY_ERROR";


export const deleteSpecialOptionCategory = id => {
    return dispatch => {
        dispatch(sendAction(DELETE_SPECIAL_OPTION_CATEGORY_REQUEST));
        axios.delete(`${apis.SPECIAL_OPTION_CATEGORIES_API}${id}/`, getAxiosTokenConfig())
            .then(() => {
                dispatch(sendAction(DELETE_SPECIAL_OPTION_CATEGORY_SUCCESS, { id }));
                notifySuccess(successes.DELETE_SPECIAL_OPTION_CATEGORY_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(DELETE_SPECIAL_OPTION_CATEGORY_ERROR, { error }));
                notifyError(errors.DELETE_SPECIAL_OPTION_CATEGORY_ERROR);
            });
    };
}


// -----------------------

export const GET_SPECIAL_OPTIONS_REQUEST = "GET_SPECIAL_OPTIONS_REQUEST";
export const GET_SPECIAL_OPTIONS_SUCCESS = "GET_SPECIAL_OPTIONS_SUCCESS";
export const GET_SPECIAL_OPTIONS_ERROR = "GET_SPECIAL_OPTIONS_ERROR";


export const getSpecialOptions = () => {
    return dispatch => {
        dispatch(sendAction(GET_SPECIAL_OPTIONS_REQUEST));
        axios.get(apis.SPECIAL_OPTIONS_API, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(GET_SPECIAL_OPTIONS_SUCCESS, { data: response.data }));
            })
            .catch(error => {
                dispatch(sendAction(GET_SPECIAL_OPTIONS_ERROR, { error }));
                notifyError(errors.GET_SPECIAL_OPTIONS_ERROR);
            });
    };
}

// ADD CONDITION
export const ADD_SPECIAL_OPTION_REQUEST = "ADD_SPECIAL_OPTION_REQUEST";
export const ADD_SPECIAL_OPTION_SUCCESS = "ADD_SPECIAL_OPTION_SUCCESS";
export const ADD_SPECIAL_OPTION_ERROR = "ADD_SPECIAL_OPTION_ERROR";


export const addSpecialOption = option => {
    return dispatch => {
        dispatch(sendAction(ADD_SPECIAL_OPTION_REQUEST));
        axios.post(apis.SPECIAL_OPTIONS_API, option, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(ADD_SPECIAL_OPTION_SUCCESS, { data: response.data }));
                notifySuccess(successes.ADD_SPECIAL_OPTION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(ADD_SPECIAL_OPTION_ERROR, { error }));
                notifyError(errors.ADD_SPECIAL_OPTION_ERROR);
            });
    };
}

// UPDATE CONDITION
export const UPDATE_SPECIAL_OPTION_REQUEST = "UPDATE_SPECIAL_OPTION_REQUEST";
export const UPDATE_SPECIAL_OPTION_SUCCESS = "UPDATE_SPECIAL_OPTION_SUCCESS";
export const UPDATE_SPECIAL_OPTION_ERROR = "UPDATE_SPECIAL_OPTION_ERROR";


export const updateSpecialOption = option => {
    return dispatch => {
        dispatch(sendAction(UPDATE_SPECIAL_OPTION_REQUEST));
        axios.patch(`${apis.SPECIAL_OPTIONS_API}${option.id}/`, option, getAxiosTokenConfig())
            .then(response => {
                dispatch(sendAction(UPDATE_SPECIAL_OPTION_SUCCESS, { data: response.data }));
                notifySuccess(successes.UPDATE_SPECIAL_OPTION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(UPDATE_SPECIAL_OPTION_ERROR, { error }));
                notifyError(errors.UPDATE_SPECIAL_OPTION_ERROR);
            });
    };
}

// DELETE CONDITION
export const DELETE_SPECIAL_OPTION_REQUEST = "DELETE_SPECIAL_OPTION_REQUEST";
export const DELETE_SPECIAL_OPTION_SUCCESS = "DELETE_SPECIAL_OPTION_SUCCESS";
export const DELETE_SPECIAL_OPTION_ERROR = "DELETE_SPECIAL_OPTION_ERROR";


export const deleteSpecialOption = id => {
    return dispatch => {
        dispatch(sendAction(DELETE_SPECIAL_OPTION_REQUEST));
        axios.delete(`${apis.SPECIAL_OPTIONS_API}${id}/`, getAxiosTokenConfig())
            .then(() => {
                dispatch(sendAction(DELETE_SPECIAL_OPTION_SUCCESS, { id }));
                notifySuccess(successes.DELETE_SPECIAL_OPTION_SUCCESS);
            })
            .catch(error => {
                dispatch(sendAction(DELETE_SPECIAL_OPTION_ERROR, { error }));
                notifyError(errors.DELETE_SPECIAL_OPTION_ERROR);
            });
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/settings.js